import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Typography, Paper, Box, Button, Card } from "@mui/material";
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import W1 from "../../images/wallet1.png";
export default function WalletComp(props) {
  return (
    <Paper
    maxWidth={false}
      sx={{
        p: "15px",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Box component="img" sx={{ height: "3.75rem", marginRight:"10px" }} src={props.img} />
      <Box sx={{display:"flex",flexDirection:"column",alignItems:"flex-start"}}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "500" }}
        >
          {props.head}
        </Typography>
        <Typography variant="h6" sx={{fontWeight:"400", color:"#666666", fontSize:"0.875rem" }}>
          5d***************fv
        </Typography>
      </Box>
      <Box sx={{marginLeft:"auto"}}><MoreVertOutlinedIcon/></Box>
    </Paper>
  );
}
